import { useAuth } from "context/AuthContext";
import { roles } from "context/AuthContext"; // Import roles doneimport SideNavigation from "../commons/components/ui/SideNavigation";
import Header from "../commons/components/ui/Header";
import { Outlet, useLocation } from "react-router-dom";
import { ApprovalsProvider } from "context/ApprovalsContext";
import AdminSideNavigation from "commons/components/ui/sidenavigation/admin/AdminSideNavigation";
import SideNavigation from "commons/components/ui/SideNavigation";
import LoginPopup from "module/ai-matchmaking/view/components/LoginPopup";
import { AnimatePresence, motion } from "framer-motion";
import { usePrefersReducedMotion } from "commons/hooks/usePrefersReducedMotion";

function Layout() {
  const { role } = useAuth(); // Access the user's role from context
  const location = useLocation();
  const reduceMotion = usePrefersReducedMotion();

  // Transition key: identifies the *page*, not the exact URL. Event-details
  // uses nested routes for its tabs (/events/:slug/overview, /events/:slug/rsvp,
  // etc.), so keying on the raw pathname made the whole page re-animate on every
  // tab switch. Collapsing all /events/:slug/* routes to a single key means the
  // page animates once when you open an event, and tab switches no longer
  // trigger the page-level transition (tabs animate themselves). Other pages
  // still key on their own pathname, so navigating between them animates.
  const getTransitionKey = (pathname) => {
    const eventDetailMatch = pathname.match(/^(\/events\/[^/]+)(?:\/.*)?$/);
    if (eventDetailMatch) return eventDetailMatch[1];
    return pathname;
  };
  const transitionKey = getTransitionKey(location.pathname);

  // Page-transition variants. A pure crossfade (opacity only) — no vertical
  // slide. The slide made page content visibly "drop in" on every navigation,
  // which looked glitchy (especially where a page renders its own header). A
  // plain fade keeps the transition smooth without shifting layout.
  const pageVariants = reduceMotion
    ? {
        initial: { opacity: 1 },
        animate: { opacity: 1 },
        exit: { opacity: 1 },
      }
    : {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      };

  const renderSideNav = () => {
    switch (role) {
      case roles.ADMIN:
        return <AdminSideNavigation />;
      case roles.BUYER:
        return <SideNavigation />;
      case roles.SELLER:
        return <SideNavigation />;
      default:
        return <SideNavigation />;
    }
  };

  return (
    <div className="flex h-screen-dynamic bg-background overflow-x-hidden">
      {/* Sidebar - Hidden on md and below */}
      <div className="hidden lg:block">
        {renderSideNav()} {/* Conditionally render sidebar */}
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col h-screen-dynamic overflow-hidden lg:ml-[220px]">
        {/* Fixed Header */}
        <div className="fixed top-0 lg:left-[220px] left-0 right-0 z-40">
          <Header />
        </div>

        {/* Main Page Content */}
        <main
          id="main-scroll-container"
          className="flex-1 pt-[60px] p-4 overflow-y-auto scroll-touch"
        >
          <ApprovalsProvider>
            <AnimatePresence mode="wait" initial={false}>
              <motion.div
                key={transitionKey}
                variants={pageVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 0.18, ease: [0.25, 0.46, 0.45, 0.94] }}
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </ApprovalsProvider>
        </main>
      </div>

      {/* AI Matchmaking Login Popup - overlay that does NOT block navigation */}
      <LoginPopup />
    </div>
  );
}

export default Layout;
